import { createAction, props } from '@ngrx/store';

export const loadSpaces = createAction('[Spaces] Load Spaces');

export const loadSpacesSuccess = createAction(
  '[Spaces] Load Spaces Success',
  props<{ spaces: any[] }>()
);

export const loadSpacesFailure = createAction(
  '[Spaces] Load Spaces Failure',
  props<{ error: any }>()
);

export const openSpaceDoor = createAction('[Spaces] Open Space Door', props<{ spaceId: string }>());

export const openSpaceDoorSuccess = createAction('[Spaces] Open Space Door Success');

export const openSpaceDoorFailure = createAction('[Spaces] Open Space Door Failure');
